<template>
  <div v-if="!loaded" v-html="info" :style="infoStyle" />
  <div v-else>
    <div v-if="formData.layout === layouts.singlePost">
      <div class="container">
        <div class="row">
          <div class="post col-md-8">
            <h1>{{ blogPostList[formData.selectedIndex].fragments.title }}</h1>
            <div class="post-meta d-flex justify-content-between">
              <!-- <div class="date">20 May | 2016</div> -->
              <div class="date">{{ blogPostList[formData.selectedIndex].createDate }}</div>
              <!-- <div class="category"><a href="#"></a></div> -->
              <div class="category">{{ blogPostList[formData.selectedIndex].author}}</div>
            </div>
            <div class="post-thumbnail">
              <img
                :src="blogPostList[formData.selectedIndex].fragments.imgSrc"
                :alt="blogPostList[formData.selectedIndex].fragments.title"
                class="img-fluid">
            </div>
            <div class="post-details">
              <p class="text-muted">
                {{ blogPostList[formData.selectedIndex].fragments.intro }}
              </p>
              <span v-html="json2Html(blogPostList[formData.selectedIndex].fragments.body)"></span>
              <div class="posts-nav d-flex justify-content-between align-items-stretch flex-column flex-md-row">
                <div @click="handleChangeSelectedIndex(-1)" class="prev-post text-left d-flex align-items-center">
                  <div class="icon prev">
                    <!-- <i class="mdi mdi-chevron-double-left"></i> -->
                    <b-icon icon="chevron-left"></b-icon>
                  </div>
                  <div class="text">
                    <strong class="text-primary">{{ getLabel4Lang(labels.PREV) }}</strong>
                    <h6>{{ blogPostList[formData.prevIndex].fragments.title }}</h6>
                  </div>
                </div>
                <div @click="handleChangeSelectedIndex(1)" class="next-post text-right d-flex align-items-center justify-content-end">
                  <div class="text"><strong class="text-primary">{{ getLabel4Lang(labels.NEXT) }}</strong>
                    <h6>{{ blogPostList[formData.nextIndex].fragments.title }}</h6>
                  </div>
                  <div class="icon next">
                    <!-- <i class="mdi mdi-chevron-double-right"></i> -->
                    <b-icon icon="chevron-right"></b-icon>
                  </div>
                </div>
              </div>
              <div class="posts-nav d-flex justify-content-between align-items-stretch flex-column flex-md-row">
                <div @click="handleSetTable()" class="prev-post text-left d-flex align-items-center">
                  <div class="icon prev">
                    <b-icon icon="chevron-double-left"></b-icon>
                  </div>
                  <div class="text">
                    <strong class="text-primary">{{ getLabel4Lang(labels.HOME) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="formData.layout === layouts.table">
      <div class="container">
        <header>
          <h2 v-if="listHeader">{{ listHeader }}</h2>
          <p v-if="listSubHeader" class="text-big">{{ listSubHeader }}</p>
        </header>
        <div class="row">
          <div v-for="(bp, ndx) in blogPostList" :key="bp.key" class="post col-md-4">
            <div class="post-thumbnail">
              <div style="cursor: pointer;" @click="handleSetSinglePost(ndx)">
                <img :src="bp.fragments.imgSrc" :alt="bp.fragments.title" class="img-fluid">
              </div>
            </div>
            <div class="post-details">
              <div class="post-meta d-flex justify-content-between">
                <div class="date">{{ bp.createDate }}</div>
                <!-- <div class="category"><a href="#"></a></div> -->
                <div class="category">{{ bp.author }}</div>
                <div v-if="bp.fragments.mulang">
                  <b-form-select v-model="bp.fragments.langLocale"
                    :options="getLangOpts(bp.mulangBPs.map(e => e.fragments.langLocale))"
                    @change="handleMulangChange($event, bp.fragments.mulangToken)"></b-form-select>
                </div>
              </div>
              <div style="cursor: pointer;" @click="handleSetSinglePost(ndx)">
                <h3 class="h4 text-primary">{{ bp.fragments.title }}</h3>
              </div>
              <p class="text-muted">{{ bp.fragments.intro }}</p>
              <div style="cursor: pointer; font-size: 0.75rem;" class="text-primary" @click="handleSetSinglePost(ndx)">
                {{ getLabel4Lang(labels.READ_MORE) }}<b-icon icon="arrow-right"></b-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import config from '@/config'
import { json2Html } from '@/service/utils/ProsemirrorConverter'
import * as htmlUtil from '@/service/utils/html'
import * as seoUtil from '@/service/utils/seo'
import { PUSH_HISTORY_STATE_DEFS, LANG_DEFS,
  BLOG_LABEL_DEFS, BLOG_LABELS } from '@/service/utils/constants'

const CONFIG_ERROR = 'Error in component configuration!',
  SERVER_API_ERROR = 'Error calling the server API!',
  LAYOUT_SINGLE_POST = 'singlePost',
  LAYOUT_LIST = 'list',
  LAYOUT_TABLE = 'table'

export default {
  name: 'gl-blog-post-list',
  version: '0.0.2',
  props: {
    instKey: {
      type: String,
      required: true
    },
    orgaKey: {
      type: String,
      required: true
    },
    keyListFilter: {
      type: String,
      required: false
    },
    tagListFilter: {
      type: String,
      required: false
    },
    listHeader: {
      type: String,
      required: false
    },
    listSubHeader: {
      type: String,
      required: false
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    genSeo: {
      type: Boolean,
      default: false
    },
    pushHistoryState: {
      type: String,
      default: undefined
    },
    phsBaseUri: {
      type: String,
      default: '/'
    },
    language: {
      type: String,
      default: 'en_EN',
      validator: (value) => Object.keys(LANG_DEFS).includes(value)
    },
    layout: {
      type: String,
      default: LAYOUT_TABLE,
      validator: function (value) {
        return [LAYOUT_SINGLE_POST, LAYOUT_LIST, LAYOUT_TABLE].indexOf(value) !== -1
      }
    }
  }, // props
  components: {}, // components
  data () {
    return {
      layouts: {
        singlePost: LAYOUT_SINGLE_POST,
        list: LAYOUT_LIST,
        table: LAYOUT_TABLE
      }, // layouts
      labels: BLOG_LABEL_DEFS,
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      initialLocationPathname: '/',
      pushStateSeparator: '',
      formData: {
        orga: { name: 'Default Blog Name' },
        layout: LAYOUT_TABLE,
        selectedIndex: 0,
        nextIndex: 0,
        prevIndex: 0
      },
      blogPostList: [],
      langSelected: this.language,
      langOpts: Object.keys(LANG_DEFS)
        .map(e => ({ value: LANG_DEFS[e], text: e }))
    }
  }, // data
  /* ----- vuejs hooks ----- */
  async mounted () {
    if ((!this.instKey) || (!this.keyListFilter && !this.tagListFilter)) {
      this.info = CONFIG_ERROR
      this.infoStyle.color = 'red'
    } else {
      try {
        const _resp = await axios.get(config.glapiBaseUri + '/content/' + this.instKey +
          '/keyListFilter/' + this.keyListFilter)
        if (_resp.data && _resp.data.status === 'success') {
          // this.blogPostList = _resp.data.payload.content
          this.blogPostList = this.groupedBlogPostList(_resp.data.payload.content)
          if (this.genSeo) {
            try {
              const _orgaResp = await axios.get(config.glapiBaseUri + '/inst/' +
                this.instKey + '/orga/' + this.orgaKey)
              if (_orgaResp.data && _orgaResp.data.status === 'success') {
                this.formData.orga = _orgaResp.data.payload.orga
                console.log('TRACE-REMOVE: BlogPostList.mounted: orga fetched! value is: ', _orgaResp.data.payload.orga)
              }
            } catch (e) {
              console.log('TRACE-REMOVE: BlogPostList.mounted: error reading orga! exception is: ', e)
            }
          }
        } else {
          throw SERVER_API_ERROR
        }

        const url = new URLSearchParams(location.search)
        this.loaded = true
        this.formData.layout = this.layout
        this.formData.selectedIndex = this.selectedIndex
        if (this.pushHistoryState) {
          if (this.pushHistoryState === PUSH_HISTORY_STATE_DEFS.QUERY_PARAM) {
            this.initialLocationPathname = location.pathname
            this.pushStateSeparator = '?key='
            const keySearchParam = url.get('key')
            if (keySearchParam) {
              for (let i=0; i < this.blogPostList.length; i++) {
                if (keySearchParam === this.blogPostList[i].key) {
                  this.formData.layout = LAYOUT_SINGLE_POST
                  this.formData.selectedIndex = i
                  break
                }
              }
            }
          } else if (this.pushHistoryState === PUSH_HISTORY_STATE_DEFS.URI) {
            if (location.pathname.startsWith(this.phsBaseUri)) {
              this.initialLocationPathname = this.phsBaseUri
              const keyParam = location.pathname.slice(this.phsBaseUri.length)
              console.log('TRACE-REMOVE: keyParam is: ', keyParam)
              if (!/[/]/.test(keyParam)) {
                console.log('TRACE-REMOVE: keyParam has no /!')
                for (let i=0; i < this.blogPostList.length; i++) {
                  console.log('TRACE-REMOVE: this.blogPostList.i.key is: ', this.blogPostList[i].key)
                  if (keyParam === this.blogPostList[i].key) {
                    this.formData.layout = LAYOUT_SINGLE_POST
                    this.formData.selectedIndex = i
                    break
                  }
                }
              } else {
                console.warn('More than one param after baseUri can not be handled!')
              }
            }
          }
        }
        if (this.formData.layout === LAYOUT_SINGLE_POST) {
          // this.handleChangeSelectedIndex(this.formData.selectedIndex, false)
          this.handleSetSinglePost(this.formData.selectedIndex)
        } else {
          this.resetJsonld()
        }
      } catch (e) {
        console.error('ERROR-REMOVE: BlogPostList.mounted: exception is: ', e)
        this.info = SERVER_API_ERROR
        this.infoStyle.color = 'red'
      }
    }
  }, // mounted
  computed: {}, // computed
  watch: {}, // watch
  methods: {
    json2Html,
    handleMulangChange (langLocaleNew, mulangToken) {
      console.log('TRACE-REMOVE: handleMulangChange: langLocaleNew is: ', langLocaleNew)
      console.log('TRACE-REMOVE: handleMulangChange: mulangToken is: ', mulangToken)
      const _bpOldNdx = this.blogPostList.findIndex(bp => bp.fragments.mulangToken === mulangToken)
      console.log('TRACE-REMOVE: handleMulangChange: _bpOldNdx is: ', _bpOldNdx)
      const _bpFound = this.blogPostList[_bpOldNdx].mulangBPs.
        find(mlbp => mlbp.fragments.langLocale === langLocaleNew)
      var _bpNew = Object.assign({}, _bpFound)
      console.log('TRACE-REMOVE: handleMulangChange: _bpNew step1 is: ', _bpNew)
      _bpNew.fragments = Object.assign({}, _bpFound.fragments)
      _bpNew.mulangBPs = this.blogPostList[_bpOldNdx].mulangBPs
      console.log('TRACE-REMOVE: handleMulangChange: _bpNew step2 is: ', _bpNew)
      Vue.set(this.blogPostList, _bpOldNdx, _bpNew)
      console.log('TRACE-REMOVE: handleMulangChange: this.blogPostList[_bpOldNdx] is: ', this.blogPostList[_bpOldNdx])
      console.log('TRACE-REMOVE: handleMulangChange: this.blogPostList[_bpOldNdx].mulangBPs after is: ', this.blogPostList[_bpOldNdx].mulangBPs)
    }, // handleMulangChange
    handleSetTable () {
      this.$emit('blog-post-details')
      this.formData.layout = LAYOUT_TABLE
      // history.pushState({}, 'some title', '/')
      // history.pushState({}, 'some title', location.pathname)
      if (this.pushHistoryState) {
        history.pushState({}, '', this.initialLocationPathname)
      }
      if (this.genSeo){
        this.resetJsonld()
      }
    }, // handleSetTable
    handleSetSinglePost (ndx) {
      this.formData.layout = LAYOUT_SINGLE_POST
      this.formData.selectedIndex = 0
      this.handleChangeSelectedIndex(ndx)
    }, // handleSetSelectedIndex
    handleChangeSelectedIndex (change, emit = true) {
      let _change = change
      if (Math.abs(change) >= this.blogPostList.length) {
        _change = change % this.blogPostList.length
      }
      if ((this.formData.selectedIndex + _change) >= (this.blogPostList.length - 1)) {
        this.formData.selectedIndex = ((this.formData.selectedIndex + _change) % this.blogPostList.length)
      } else if ((this.formData.selectedIndex + _change) < 0) {
        this.formData.selectedIndex = this.blogPostList.length + _change
      } else {
        this.formData.selectedIndex += _change
      }
      if ((this.formData.selectedIndex + 1) > (this.blogPostList.length - 1)) {
        this.formData.nextIndex = 0
      } else {
        this.formData.nextIndex = this.formData.selectedIndex + 1
      }
      if ((this.formData.selectedIndex - 1) < 0) {
        this.formData.prevIndex = this.blogPostList.length - 1
      } else {
        this.formData.prevIndex = this.formData.selectedIndex - 1
      }
      if (emit) {
        this.$emit('blog-post-details', this.blogPostList[this.formData.selectedIndex].key)
      }
      // history.pushState({}, 'some title', '/' + this.blogPostList[this.formData.selectedIndex].key)
      // history.pushState({}, 'some title', location.pathname + this.blogPostList[this.formData.selectedIndex].key)
      if (this.pushHistoryState) {
        history.pushState({}, '', this.initialLocationPathname +
          this.pushStateSeparator +
          this.blogPostList[this.formData.selectedIndex].key)
      }
      if (this.genSeo) {
        this.resetJsonld()
      }
    }, // handleChangeSelectedIndex
    /* ----- helper methods ----- */
    // TODO: create functions to initialize the templates
    resetJsonld() {
      console.log('TRACE-REMOVE: BlogPostList.resetJsonld: location is: ',
        window.location)
      const _locationHref = window.location.href
      console.log('TRACE-REMOVE: BlogPostList.resetJsonld: _locationHref is: ',
        _locationHref)
      console.log('TRACE-REMOVE: BlogPostList.resetJsonld: location.href is: ',
        window.location.href)
      let _blog = null
      if (this.formData.layout === LAYOUT_SINGLE_POST) {
        _blog = seoUtil.DEFAULT_BLOG_POSTING()
        let bp = this.blogPostList[this.formData.selectedIndex]
        // _blog.mainEntityOfPage = window.location.href + '/' + bp.key
        // _blog.mainEntityOfPage = window.location.href
        _blog.mainEntityOfPage['@id'] = window.location.href
        // console.log('TRACE-REMOVE: BlogPostList.resetJsonld: _blog.mainEntityOfPage is: ', _blog.mainEntityOfPage)
        // _blog.headline = bp.fragments.intro.substring(0, 110)
        _blog.headline = bp.fragments.title
        _blog.description = bp.fragments.intro
        // TODO: author must be added
        // _blog.author = bp.author
        _blog.author = bp.author || 'author'
        _blog.datePublished = bp.createDate
        _blog.dateModified = bp.lastUpdated ? bp.lastUpdated : bp.createDate
        _blog.image.url = bp.fragments.imgSrc
        // TODO: image width and height
        _blog.publisher.name = this.formData.orga.name
        _blog.publisher.logo.url = this.formData.orga.logoUrl
      } else if (this.formData.layout === LAYOUT_TABLE) {
        _blog = seoUtil.DEFAULT_BLOG()
        _blog.name = this.formData.orga.name
        _blog.url = window.location.href
        _blog.description = this.formData.orga.description
        _blog.publisher.name = this.formData.orga.name

        for (let bp of this.blogPostList) {
          const _blogPost = seoUtil.DEFAULT_BLOG_POSTING()
          _blogPost.mainEntityOfPage = window.location.href + this.pushStateSeparator + bp.key
          // console.log('TRACE-REMOVE: BlogPostList.resetJsonld: _blogPost.mainEntityOfPage is: ', _blogPost.mainEntityOfPage)
          // _blogPost.headline = bp.fragments.intro.substring(0, 110)
          _blogPost.headline = bp.fragments.title
          _blogPost.description = bp.fragments.intro
          // TODO: author must be added
          // _blogPost.author = bp.author
          _blogPost.author = bp.author || 'author'
          _blogPost.datePublished = bp.createDate
          _blogPost.dateModified = bp.lastUpdated ? bp.lastUpdated : bp.createDate
          _blogPost.image.url = bp.fragments.imgSrc
          // TODO: image width and height
          _blogPost.publisher.name = this.formData.orga.name
          _blogPost.publisher.logo.url = this.formData.orga.logoUrl
          _blog.blogPost.push(_blogPost)
        }
      }
      htmlUtil.addJsonldToHead(_blog ? JSON.stringify(_blog) : null)
    }, // resetJsonld
    getLabel4Lang (label) {
      return BLOG_LABELS[this.language][label]
    }, // getLabel4Lang
    groupBy: (x, f) => x.reduce((a, b) => ((a[f(b)] ||= []).push(b), a), {}),
    groupedBlogPostList (bpl) {
      const st1BPL = this.groupBy(bpl, v => v.fragments.mulangToken)
      const nonMulangBP = [...st1BPL['null'] ?? [], ...st1BPL['undefined'] ?? []]
      const mulangBP = Object.keys(st1BPL).
        filter(e => e !== 'undefined' && e !== 'null').
        map(k => {
          const _mulangBPFound = st1BPL[k].find(f => f.fragments.mulangDefault)
          const _mulangBP = Object.assign({}, _mulangBPFound)
          _mulangBP.fragments = Object.assign({}, _mulangBPFound.fragments)
          _mulangBP.mulangBPs = st1BPL[k]
          return _mulangBP
        })
      return [...nonMulangBP, ...mulangBP]
    }, // groupedBlogPostList
    getLangOpts (bpl) {
      return Object.keys(LANG_DEFS).
        filter(k =>  bpl.includes(LANG_DEFS[k])).
        map(km => ({ value: LANG_DEFS[km], text: km }))
    } // getLangOpts
  } // methods
}
</script>

<style lang="css" scoped>
@import '~bootstrap/dist/css/bootstrap.css';

header {
  margin-bottom: 50px;
}

.category a {
  color: #999;
  letter-spacing: 0.08em;
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 13px;
}

.category a::after {
  content: ',';
  color: #ddd;
  display: inline-block;
  margin-right: 5px;
}

.category a:last-of-type::after {
  display: none;
}

.category a:hover {
  color: #000;
}

.post-thumbnail img {
  width: 100%;
  margin-bottom: 10px;
}

.post-meta {
  margin: 10px 0;
  font-size: 0.8em;
}

.post-meta .date {
  text-transform: uppercase;
  font-weight: 400;
}

.post-meta .date::after {
  display: none;
}

.post .category a {
  color: #999;
  letter-spacing: 0.05em;
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: none;
}

.next-post, .prev-post {
  cursor: pointer;
}
</style>
